import React, { useState } from 'react'
import { Box, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import OtherConfigCommonFilter from './OtherConfigCommonFilter'
import { Item } from '../../../../../common/snippets'
import OtherConfigCommonBottom from './OtherConfigCommonBottom'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
const BookingDeliveryOTP = (props) => {
    const { tabInfo } = props
    const { resetFlag, setResetFlag, resetAllValueBrnhMaster, getBranchCargoData,
        brnhOtherCargoValue, setBrnchOtherCargoValue, confModal, setConfModal, isDisableBtn,
        handleBack, showBottom, setShowBottom, onSave } = tabInfo
    const [searchResult, setSearchResult] = useState(false)
    const handleBrnhCargoValue = (value, field, prevValue) => {
        if (value != prevValue) {
            let updatedValues = { [field]: value };
            // if (field === 'IsRecipientDeliveryOTP') {
            //     updatedValues.HasRecOtpDel = value === 1 ? 0 : 1;
            //     updatedValues.RecDelOtpAll = value === 1 ? 0 : 1;
            //     updatedValues.RecDelOtpOnAcc = value === 1 ? 0 : 1;
            // }
            if (field === 'HasRecOtpDel') {
                updatedValues.RecDelOtpAll = value === 1 ? 1 : 0;
                updatedValues.RecDelOtpOnAcc = value === 1 ? 1 : 0;
                // updatedValues.IsRecipientDeliveryOTP = value === 1 ? 0 : 1;
            }
            if (field === 'HasRecOtpBkg') {
                updatedValues.RecBkgOtpAll = value === 1 ? 1 : 0;
                updatedValues.RecBkgOtpOnAcc = value === 1 ? 1 : 0;
            }
            if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
                setConfModal((prev) => ({
                    ...prev,
                    branchOtherConfig: true
                }))
            }
            setBrnchOtherCargoValue((prev) => ({ ...prev, ...updatedValues }))
        }
    }
    return (
        !searchResult ?
            <>
                <OtherConfigCommonFilter
                    resetAllValueBrnhMaster={() => {
                        resetAllValueBrnhMaster();
                        setResetFlag(!resetFlag)
                    }}
                    getData={getBranchCargoData} nextId='gst' setShowBottom={setShowBottom} />
                <Divider />
                {showBottom && <>
                    <Grid container sx={{ padding: '6px 8px' }}>
                        <Grid item md={2.4} style={{ paddingLeft: '0px' }}>
                            <Item style={{ paddingRight: '0px', width: '300px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.HasRecOtpBkg === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            Book With OTP (Sender)
                                        </Typography>
                                    }
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'HasRecOtpBkg', brnhOtherCargoValue?.HasRecOtpBkg)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                        <Grid item md={2.3} style={{ paddingLeft: '0px' }}>
                            <Item style={{ paddingRight: '0px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.RecBkgOtpAll === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            All Pay Type
                                        </Typography>
                                    }
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'RecBkgOtpAll', brnhOtherCargoValue?.RecBkgOtpAll)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                            <Item style={{ paddingRight: '0px',marginTop:'-20px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.RecBkgOtpOnAcc === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            On Account
                                        </Typography>
                                    }
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'RecBkgOtpOnAcc', brnhOtherCargoValue?.RecBkgOtpOnAcc)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                        <Grid item md={1.7} style={{ paddingLeft: '0px' }}>
                            <Item style={{ paddingRight: '0px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.HasRecOtpDel === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            Delivery With OTP (Receiver)
                                        </Typography>
                                    }
                                    disabled={brnhOtherCargoValue?.IsRecipientDeliveryOTP === 1}
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'HasRecOtpDel', brnhOtherCargoValue?.HasRecOtpDel)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                        <Grid item md={1.7} style={{ paddingLeft: '0px' }}>
                            <Item style={{ paddingRight: '0px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.RecDelOtpAll === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            All Pay Type
                                        </Typography>
                                    }
                                    disabled={brnhOtherCargoValue?.IsRecipientDeliveryOTP === 1}
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'RecDelOtpAll', brnhOtherCargoValue?.RecDelOtpAll)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                            <Item style={{ paddingRight: '0px',marginTop:'-20px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.RecDelOtpOnAcc === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            On Account
                                        </Typography>
                                    }
                                    disabled={brnhOtherCargoValue?.IsRecipientDeliveryOTP === 1}
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'RecDelOtpOnAcc', brnhOtherCargoValue?.RecDelOtpOnAcc)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                        <Grid item md={1} style={{ paddingLeft: '0px' }}>
                          <Item style={{ paddingRight: '0px',marginTop:'10px'}}>
                                <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                    OR
                                </Typography>
                            </Item>
                        </Grid>
                        <Grid item md={1.7} style={{ paddingLeft: '0px' }}>
                            <Item style={{ paddingRight: '0px' }}>
                                <FormControlLabel
                                    value="end"
                                    tabIndex={0}
                                    control={<Checkbox tabIndex={0} checked={brnhOtherCargoValue?.IsRecipientDeliveryOTP === 1} id='gst-cargoC' />}
                                    // onKeyDown={(e) => {
                                    //     navigation3(e, "gst-cargoS", 'gst', () => { })
                                    // }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            Delivery With OTP (Recipient)
                                        </Typography>
                                    }
                                    disabled={brnhOtherCargoValue?.HasRecOtpDel === 1}
                                    onChange={(event) => {
                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, 'IsRecipientDeliveryOTP', brnhOtherCargoValue?.IsRecipientDeliveryOTP)
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                    </Grid>
                    <Divider />
                    <OtherConfigCommonBottom onSave={onSave} handleBack={handleBack} setSearchResult={setSearchResult} fileName={'gst'} hideExcelPdfPrint={true}/>
                </>
                }

            </>
            :<></>
    )
}

export default BookingDeliveryOTP